import Icon from '@/components/shared/icons'
import ContactEntity from '@/entities/api/users/contact'
import DateConvert from '@/utils/date-convert'
import { statusConvert } from '@/utils/status-contact-convert'
import { Badge, Box, Flex, Text } from '@chakra-ui/react'

const UsersRequestCard = ({
	click,
	contact,
}: {
	click?: (contact : ContactEntity) => void
	contact: ContactEntity
}) => {
	return (
		<Box
			bg='white'
			borderRadius='md'
			boxShadow='sm'
			overflow='hidden'
			mt='4'
			mb='4'
			cursor='pointer'
			onClick={() => click?.(contact)}
		>
			<Box bg='gray.50' p={{ base: 2, sm: 4, md: 6 }} borderTopRadius='md'>
				<Flex justify='space-between' align='center'>
					<Box>
						<Text
							color='black'
							fontSize={{ base: 'sm', sm: 'md', md: 'lg' }}
							fontWeight='bold'
						>
							{contact._id ?? ''}
						</Text>
						<Text fontSize='sm' color='gray.700'>
							{DateConvert(contact._created ?? '')}
						</Text>
					</Box>
					<Badge
						bg='black'
						color='white'
						fontSize='sm'
						fontWeight='bold'
						px={{ base: 2, sm: 3 }}
						py='1'
						borderRadius='md'
					>
						{statusConvert(contact.status)}
					</Badge>
				</Flex>
			</Box>

			<Box p={{ base: 2, sm: 4, md: 6 }}>
				<Box mb='2'>
					<Text fontSize='sm' color='gray.500' mb={1}>
						Solicitante
					</Text>
					<Box p='2'>
						<Text fontSize='lg' fontWeight='semibold' color='gray.800' mb={4}>
							{contact.fullname}
						</Text>
						<Flex direction='column' gap={3}>
							<Flex align='center' gap={2}>
								<Icon icon='phone' size='lg' color='black' />
								<Text
									fontSize={{ base: 'sm', sm: 'md' }}
									fontWeight='medium'
									color='gray.700'
									ml='4'
								>
									{contact.phone}
								</Text>
							</Flex>
							<Flex align='center' gap={2}>
								<Icon icon='email' size='lg' color='black' />
								<Text
									fontSize={{ base: 'sm', sm: 'md' }}
									fontWeight='medium'
									color='gray.700'
									ml='4'
								>
									{contact.email}
								</Text>
							</Flex>
						</Flex>
					</Box>
				</Box>

				<Box bg='gray.50' p={4} borderRadius='md' mb={4}>
					<Text
						fontSize={{ base: 'sm', sm: 'md' }}
						color='black'
						fontWeight='bold'
						mb={1}
					>
						Mensaje
					</Text>
					<Text fontSize={{ base: 'sm', sm: 'md' }} color='gray.700'>
						{contact.message}
					</Text>
				</Box>

				{contact.response && (
					<Box bg='gray.50' p={4} borderRadius='md'>
						<Text
							fontSize={{ base: 'sm', sm: 'md' }}
							color='black'
							fontWeight='bold'
							mb={1}
						>
							Respuesta
						</Text>
						<Text fontSize={{ base: 'sm', sm: 'md' }} color='gray.700'>
							{contact.response}
						</Text>
					</Box>
				)}
			</Box>
		</Box>
	)
}

export default UsersRequestCard
